import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-aprove-errorpopup',
  templateUrl: './aprove-errorpopup.component.html',
  styleUrls: ['./aprove-errorpopup.component.scss']
})
export class AproveErrorpopupComponent {

  warnings: any[] = [];

  constructor(
    private dialogRef: MatDialogRef<AproveErrorpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.warnings = data?.warnings || [];
  }

  closeModal() {
    this.dialogRef.close('close');
  }

  proceedAnyway() {
    this.dialogRef.close('proceed');
  }

}